import { useSelector } from "react-redux";
import { validators, formats, dates } from "investira.sdk";
import {
  Tooltip,
  Stack,
  Chip,
  Typography,
  CircularProgress,
} from "investira.react.components";
import { OUTPUT } from "../../enums";

const columns = {
  [OUTPUT.duration.id]: [
    {
      id: "criacao",
      accessorKey: "created",
      header: "Criação",
      enableColumnActions: false,
      enableSorting: false,
      Cell: ({ cell }) => {
        if (validators.isNull(cell.getValue())) {
          return null;
        }
        return formats.formatDate(dates.toDate(cell.getValue()));
      },
    },
    {
      id: "carteira",
      accessorKey: "request_metadata",
      header: "Carteira",
      enableColumnActions: false,
      enableSorting: false,
      Cell: ({ cell }) => {
        if (validators.isNull(cell.getValue())) {
          return;
        }
        return cell.getValue().carteira;
      },
    },
    {
      id: "posicao",
      accessorKey: "request",
      header: "Data Posição",
      enableColumnActions: false,
      enableSorting: false,
      Cell: ({ cell }) => {
        if (validators.isNull(cell.getValue())) {
          return;
        }
        return formats.formatDate(dates.toDate(cell.getValue().data));
      },
    },
    {
      id: "juros",
      accessorKey: "request",
      header: "Juros Delta",
      enableColumnActions: false,
      enableSorting: true,
      //maxSize: 100,
      muiTableHeadCellProps: {
        align: "right",
      },
      muiTableBodyCellProps: {
        align: "right",
      },
      Cell: ({ cell }) => {
        if (validators.isNull(cell.getValue().juros_delta)) {
          return null;
        }
        return `${cell.getValue().juros_delta.toFixed(4)}%`;
      },
    },
    {
      id: "error",
      accessorKey: "error",
      header: "Status",
      enableColumnActions: false,
      enableSorting: false,
      Cell: (xProps) => {
        const { cell, row } = xProps;

        if (!validators.isNull(cell.getValue())) {
          const xError = row.original.error;
          return (
            <Tooltip
              arrow
              title={
                <Stack
                  spacing={1}
                  sx={{
                    px: 3,
                    py: 2,

                    whiteSpace: "normal",
                  }}
                >
                  <Stack spacing={1}>
                    <Typography variant="caption" color="textPrimary">
                      {xError}
                    </Typography>
                  </Stack>
                </Stack>
              }
            >
              <span>
                <Chip size="small" label="Erro" color="error" />
              </span>
            </Tooltip>
          );
        }

        return <Chip size="small" label="Ok" color="success" />;
      },
    },
  ],
  [OUTPUT.enquadramento.id]: [
    {
      id: "criacao",
      accessorKey: "created",
      header: "Criação",
      enableColumnActions: false,
      enableSorting: false,
      maxSize: 100,
      Cell: ({ cell }) => {
        if (validators.isNull(cell.getValue())) {
          return null;
        }
        return formats.formatDate(dates.toDate(cell.getValue()));
      },
    },
    {
      id: "carteira",
      accessorKey: "request_metadata",
      header: "Carteira",
      enableColumnActions: false,
      enableSorting: false,
      Cell: ({ cell }) => {
        if (validators.isNull(cell.getValue())) {
          return;
        }
        return cell.getValue().carteira;
      },
    },
    {
      id: "posicao",
      accessorKey: "request",
      header: "Data Posição",
      enableColumnActions: false,
      enableSorting: false,
      maxSize: 100,
      Cell: ({ cell }) => {
        if (validators.isNull(cell.getValue())) {
          return;
        }
        return formats.formatDate(dates.toDate(cell.getValue().data));
      },
    },

    {
      id: "enquadramento",
      accessorKey: "request_metadata",
      header: "Enquadramento",
      enableColumnActions: false,
      enableSorting: false,
      Cell: ({ cell }) => {
        if (validators.isNull(cell.getValue())) {
          return;
        }
        return cell.getValue().enquadramento;
      },
    },
    {
      id: "concentracao_por_emissor",
      accessorKey: "concentracao_por_emissor",
      header: "Concentração por Emissor",
      enableColumnActions: false,
      enableSorting: false,
      Cell: ({ cell }) => {
        if (validators.isNull(cell.getValue())) {
          return;
        }
        //Individual
        //Carteira Próprias
        //Carteiras do Portfólio
        return cell.getValue();
      },
    },
    {
      id: "error",
      accessorKey: "error",
      header: "Status",
      enableColumnActions: false,
      enableSorting: false,
      maxSize: 70,
      Cell: (xProps) => {
        const { cell, row } = xProps;

        if (!validators.isNull(cell.getValue())) {
          const xError = row.original.error;
          return (
            <Tooltip
              arrow
              title={
                <Stack
                  spacing={1}
                  sx={{
                    px: 3,
                    py: 2,

                    whiteSpace: "normal",
                  }}
                >
                  <Stack spacing={1}>
                    <Typography variant="caption" color="textPrimary">
                      {xError}
                    </Typography>
                  </Stack>
                </Stack>
              }
            >
              <span>
                <Chip size="small" label="Erro" color="error" />
              </span>
            </Tooltip>
          );
        }

        return <Chip size="small" label="Ok" color="success" />;
      },
    },
  ],
  [OUTPUT.raiox.id]: [
    {
      id: "carteira",
      accessorKey: "carteira_id",
      header: "Carteira",
      enableColumnActions: false,
      enableSorting: false,
    },
    {
      id: "posicao",
      accessorKey: "data_posicao",
      header: "Data Posição",
      enableColumnActions: false,
      enableSorting: false,
      Cell: ({ cell }) => {
        if (validators.isNull(cell.getValue())) {
          return;
        }
        return formats.formatDate(dates.toDate(cell.getValue()));
      },
    },
    {
      id: "data",
      accessorKey: "data",
      header: "Data",
      enableColumnActions: false,
      enableSorting: false,
      Cell: ({ cell }) => {
        if (validators.isNull(cell.getValue())) {
          return;
        }
        return formats.formatDate(dates.toDate(cell.getValue()));
      },
    },
    {
      id: "juros",
      accessorKey: "payload.juros_delta",
      header: "Juros Delta",
      enableColumnActions: false,
      enableSorting: false,
      Cell: ({ cell }) => {
        if (validators.isNull(cell.getValue())) {
          return null;
        }
        return `${cell.getValue().toFixed(4)}%`;
      },
    },
    {
      id: "logid",
      accessorKey: "log_id",
      header: "Log ID",
      enableColumnActions: false,
      enableSorting: false,
    },
    {
      id: "criacao",
      accessorKey: "created",
      header: "Criação",
      enableColumnActions: false,
      enableSorting: false,
      Cell: ({ cell }) => {
        if (validators.isNull(cell.getValue())) {
          return null;
        }
        return formats.formatDate(dates.toDate(cell.getValue()));
      },
    },
    {
      id: "status",
      accessorKey: "processamento_arquivo",
      header: "Status",
      enableColumnActions: false,
      enableSorting: false,
      Cell: (xProps) => {
        // console.log(xProps);
        const { cell, row } = xProps;

        if (!validators.isEmpty(row.original.processamento_erros)) {
          const xError = row.original.processamento_erros;
          return (
            <Tooltip
              arrow
              title={
                <Stack
                  spacing={1}
                  sx={{
                    px: 3,
                    py: 2,

                    whiteSpace: "normal",
                  }}
                >
                  <Stack spacing={1}>
                    <Typography variant="caption" color="textPrimary">
                      {xError.description || xError}
                    </Typography>
                  </Stack>
                </Stack>
              }
            >
              <span>
                <Chip size="small" label="Erro" color="error" />
              </span>
            </Tooltip>
          );
        }

        if (validators.isNull(cell.getValue())) {
          return <Chip size="small" label="Processando" color="warn" />;
        }

        return <Chip size="small" label="Ok" color="success" />;
      },
    },
  ],
  [OUTPUT.rentabilidade.id]: [
    {
      id: "carteira",
      accessorKey: "carteira_id",
      header: "Carteira",
      enableColumnActions: false,
      enableSorting: false,
    },
    {
      id: "posicao",
      accessorKey: "data_posicao",
      header: "Data Posição",
      enableColumnActions: false,
      enableSorting: false,
      Cell: ({ cell }) => {
        if (validators.isNull(cell.getValue())) {
          return;
        }
        return formats.formatDate(dates.toDate(cell.getValue()));
      },
    },
    {
      id: "data",
      accessorKey: "data",
      header: "Data",
      enableColumnActions: false,
      enableSorting: false,
      Cell: ({ cell }) => {
        if (validators.isNull(cell.getValue())) {
          return;
        }
        return formats.formatDate(dates.toDate(cell.getValue()));
      },
    },
    {
      id: "juros",
      accessorKey: "payload.juros_delta",
      header: "Juros Delta",
      enableColumnActions: false,
      enableSorting: false,
      Cell: ({ cell }) => {
        if (validators.isNull(cell.getValue())) {
          return null;
        }
        return `${cell.getValue().toFixed(4)}%`;
      },
    },
    {
      id: "logid",
      accessorKey: "log_id",
      header: "Log ID",
      enableColumnActions: false,
      enableSorting: false,
    },
    {
      id: "criacao",
      accessorKey: "created",
      header: "Criação",
      enableColumnActions: false,
      enableSorting: false,
      Cell: ({ cell }) => {
        if (validators.isNull(cell.getValue())) {
          return null;
        }
        return formats.formatDate(dates.toDate(cell.getValue()));
      },
    },
    {
      id: "status",
      accessorKey: "processamento_arquivo",
      header: "Status",
      enableColumnActions: false,
      enableSorting: false,
      Cell: (xProps) => {
        // console.log(xProps);
        const { cell, row } = xProps;

        if (!validators.isEmpty(row.original.processamento_erros)) {
          const xError = row.original.processamento_erros;
          return (
            <Tooltip
              arrow
              title={
                <Stack
                  spacing={1}
                  sx={{
                    px: 3,
                    py: 2,

                    whiteSpace: "normal",
                  }}
                >
                  <Stack spacing={1}>
                    <Typography variant="caption" color="textPrimary">
                      {xError.description || xError}
                    </Typography>
                  </Stack>
                </Stack>
              }
            >
              <span>
                <Chip size="small" label="Erro" color="error" />
              </span>
            </Tooltip>
          );
        }

        if (validators.isNull(cell.getValue())) {
          return <Chip size="small" label="Processando" color="warn" />;
        }

        return <Chip size="small" label="Ok" color="success" />;
      },
    },
  ],
  [OUTPUT.var.id]: [
    {
      id: "carteira",
      accessorKey: "carteira_id",
      header: "Carteira",
      enableColumnActions: false,
      enableSorting: false,
    },
    {
      id: "posicao",
      accessorKey: "data_posicao",
      header: "Data Posição",
      enableColumnActions: false,
      enableSorting: false,
      Cell: ({ cell }) => {
        if (validators.isNull(cell.getValue())) {
          return;
        }
        return formats.formatDate(dates.toDate(cell.getValue()));
      },
    },
    {
      id: "data",
      accessorKey: "data",
      header: "Data",
      enableColumnActions: false,
      enableSorting: false,
      Cell: ({ cell }) => {
        if (validators.isNull(cell.getValue())) {
          return;
        }
        return formats.formatDate(dates.toDate(cell.getValue()));
      },
    },
    {
      id: "juros",
      accessorKey: "payload.juros_delta",
      header: "Juros Delta",
      enableColumnActions: false,
      enableSorting: false,
      Cell: ({ cell }) => {
        if (validators.isNull(cell.getValue())) {
          return null;
        }
        return `${cell.getValue().toFixed(4)}%`;
      },
    },
    {
      id: "logid",
      accessorKey: "log_id",
      header: "Log ID",
      enableColumnActions: false,
      enableSorting: false,
    },
    {
      id: "criacao",
      accessorKey: "created",
      header: "Criação",
      enableColumnActions: false,
      enableSorting: false,
      Cell: ({ cell }) => {
        if (validators.isNull(cell.getValue())) {
          return null;
        }
        return formats.formatDate(dates.toDate(cell.getValue()));
      },
    },
    {
      id: "status",
      accessorKey: "processamento_arquivo",
      header: "Status",
      enableColumnActions: false,
      enableSorting: false,
      Cell: (xProps) => {
        // console.log(xProps);
        const { cell, row } = xProps;

        if (!validators.isEmpty(row.original.processamento_erros)) {
          const xError = row.original.processamento_erros;
          return (
            <Tooltip
              arrow
              title={
                <Stack
                  spacing={1}
                  sx={{
                    px: 3,
                    py: 2,

                    whiteSpace: "normal",
                  }}
                >
                  <Stack spacing={1}>
                    <Typography variant="caption" color="textPrimary">
                      {xError.description || xError}
                    </Typography>
                  </Stack>
                </Stack>
              }
            >
              <span>
                <Chip size="small" label="Erro" color="error" />
              </span>
            </Tooltip>
          );
        }

        if (validators.isNull(cell.getValue())) {
          return <Chip size="small" label="Processando" color="warn" />;
        }

        return <Chip size="small" label="Ok" color="success" />;
      },
    },
  ],
};

export default columns;
